import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ui-input-date__label"
}
const _hoisted_2 = { class: "ui-input-date__input" }
const _hoisted_3 = {
  key: 1,
  class: "ui-input-date__error",
  "data-error": "true"
}

import { computed, onMounted } from 'vue'

// Use
import { useVModel } from '@vueuse/core'
import useThemeClassName from '@/hooks/useThemeClassName'

// Components
import { ElDatePicker } from 'element-plus'
import HintText from '@/components/ui/HintText'

// Types
import type { Props } from './index'

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'InputDate',
  props: {
    theme: {},
    label: {},
    placeholder: {},
    name: {},
    modelValue: {},
    value: {},
    hint: {},
    format: { default: 'DD.MM.YYYY' },
    valueFormat: { default: 'DD.MM.YYYY' },
    error: {}
  },
  emits: ["update:modelValue", "update:error"],
  setup(__props: any, { emit: __emit }) {

const props = __props


// Emits
const emit = __emit

// Data
let model = useVModel(props, 'modelValue', emit)
const proxiedError = useVModel(props, 'error', emit)

// Computed
const themeClassName = computed(() => useThemeClassName('ui-input-date', props.theme))
const text = computed<string | null>(() => props.placeholder ?? props.label ?? null)

// Methods
function clearError(): void {
  proxiedError.value = null
}

onMounted(() => {
  if (props.value) {
    model.value = props.value
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ui-input-date", [themeClassName.value]]),
    onClick: clearError
  }, [
    (text.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(text.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ElDatePicker), {
        onVisibleChange: clearError,
        type: "date",
        name: _ctx.name,
        format: _ctx.format,
        "value-format": _ctx.valueFormat,
        modelValue: _unref(model),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event))
      }, null, 8, ["name", "format", "value-format", "modelValue"])
    ]),
    (_unref(proxiedError))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(proxiedError)), 1))
      : _createCommentVNode("", true),
    (_ctx.hint)
      ? (_openBlock(), _createBlock(_unref(HintText), {
          key: 2,
          "link-text": _ctx.hint.link,
          "hint-text": _ctx.hint.text,
          class: "ui-input-date__hint"
        }, null, 8, ["link-text", "hint-text"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})